/**
 * Provides utilities for validating URLs.
 *
 * @module UrlValidator
 * @see {@link https://urlregex.com/} - Ruby version (modified to exclude ftp)
 */
/**
 * The default regex pattern used to validate URLs.
 * This pattern conforms to the general url format.
 *
 * @constant
 * @type {RegExp}
 */
export const REGEX_URL_VALIDATOR_PATTERN = /^(https?:\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
/**
 * The error message used when an expected regex pattern is not set.
 *
 * @constant
 * @type {string}
 */
export const REGEX_URL_VALIDATOR_ERROR = 'Regular expression for URL validations not set';
export class UrlValidator {
    constructor(regex = REGEX_URL_VALIDATOR_PATTERN) {
        this.regex = regex;
        if (!regex) {
            throw new Error(REGEX_URL_VALIDATOR_ERROR);
        }
    }
    validate(url) {
        return this.regex.test(url);
    }
}
//# sourceMappingURL=UrlValidator.js.map